var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var Hide = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M4.5 3.75L19.5 20.25M14.5219 14.775C13.8337 15.4054 12.9333 15.7535 12 15.75C11.2431 15.7499 10.504 15.5208 9.87975 15.0928C9.25552 14.6648 8.77542 14.0579 8.50256 13.3519C8.2297 12.6459 8.17686 11.8739 8.35098 11.1373C8.5251 10.4007 8.91804 9.73408 9.47813 9.225M6.9375 6.43125C3.1125 8.3625 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C13.7574 18.7643 15.4929 18.3594 17.0625 17.5687M19.5563 15.8531C21.6 14.025 22.5 12 22.5 12C22.5 12 19.5 5.25 12 5.25C11.3498 5.24872 10.7007 5.30203 10.0594 5.40938M12.7031 8.31562C13.5006 8.46673 14.2273 8.87312 14.7735 9.47348C15.3198 10.0738 15.6559 10.8356 15.7313 11.6437", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
